import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-189">
          <div className="flex flex-col items-center justify-center" data-id="element-190">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-191">⭐ 4.9</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-192">
              500+ ventas
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-193">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-194">100</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-195">
              Modelos editables
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-196">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-197">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-198">
              Jurisprudencia actual
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-199">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-200">7 días</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-201">
              Garantía total
            </span>
          </div>
        </div>
      </div>
    </div>;
};